module.exports = __webpack_public_path__ + "img/upgrade.d7a9b94a.svg";